import basicController from "servicestack/basic.controller.properties";
import $resolve from "ng";
import authConfig from "emun.auth/auth.config"; //get shared
import modals from "webmodals/modals";
import resetPasswordPrompt from "emun.auth/reset-password/reset-password-prompt";

export default class ChangePasswordController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.config = authConfig;
    $ctrl.bus = $ctrl.$session.bus;
    delete $ctrl.bus.validationErrors;
    console.debug("ChangePasswordController", this);
  }

  $onInit() {
    const $ctrl = this;
    console.info("request", $ctrl.request);
    if (!$ctrl.request) {
      $ctrl.request = Object.assign(
        { callbackUrl: window.location.href },
        $resolve("$location").search()
      );
      ["callbackUrl", "resetId", "token"].forEach(n => {
        if ($ctrl[n] && $ctrl[n].length) {
          $ctrl.request[n] = $ctrl[n];
        }
      });
    }
  }

  submit() {
    let $ctrl = this;
    const $notify = $resolve("notify");
    return $ctrl.$session.changePassword($ctrl.request).then(
      res => {
        console.debug("requested password reset", res);
        $ctrl.$dismiss && $ctrl.$dismiss("resetPassword", res.data);
        $ctrl.onSuccess && $ctrl.onSuccess(res.data);
        modals.alert(
          "You have successfully changed your password and you are now logged in",
          "Password Change Successful"
        );
        $notify.success("Password was successfully changed", {
          title: "Change Password",
          ttl: 5000
        });
        if ($ctrl.request.resetId) {
          window.location = $ctrl.onSuccessUrl || "/";
        }
      },
        failed => {
          //console.debug("BL*** failed", failed.data.responseStatus);
          $notify.error("Password change failed", {
            title: "Change Password",
            ttl: 5000
          });
        $ctrl.onFail && $ctrl.onFail(failed.data.responseStatus);
        $ctrl.errors = failed.data.responseStatus;
      }
    );
  }

  resetPassword() {
    let $ctrl = this;
    console.log("resetPassword");
    $ctrl.bus.validationErrors = [];
    $ctrl.$dismiss("resetPassword");
    return resetPasswordPrompt({ email: $ctrl.request.userName });
  }
}
